export default function Stack({ children, gap = "4", className = "", as: Tag = "div" }) {
  return (
    <Tag className={className} style={{ display: "flex", flexDirection: "column", gap: `var(--s${gap})` }}>
      {children}
    </Tag>
  );
}
